import { normalizePointType } from "@utils/maps/mapGeometry";

export function createRouteShapePointElement() {
  const element = document.createElement("div");
  element.className = "walking-route-shape-marker";
  element.title = "Drag to adjust route.";
  const dot = document.createElement("span");
  dot.className = "walking-route-shape-marker-dot";
  element.appendChild(dot);
  return element;
}

export function createStartPointMarkerElement() {
  const element = document.createElement("div");
  element.className = "start-point-map-marker";
  element.innerHTML = `
      <svg viewBox="0 0 24 24" class="start-point-map-marker-icon" aria-hidden="true">
        <path fill="currentColor" d="M5 3a1 1 0 0 1 1 1v16a1 1 0 1 1-2 0V4a1 1 0 0 1 1-1zm3 1h7.2c.95 0 1.67.92 1.38 1.82L15.3 9l1.28 3.18c.29.9-.43 1.82-1.38 1.82H8a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1z"/>
      </svg>
    `;
  return element;
}

function createLabeledMarkerElement(className, labelClassName, label) {
  const element = document.createElement("div");
  element.className = className;
  const labelSpan = document.createElement("span");
  labelSpan.className = labelClassName;
  labelSpan.textContent = String(label || "");
  element.appendChild(labelSpan);
  return element;
}

export function createModeDrivingMarkerElement(label = "") {
  return createLabeledMarkerElement(
    "mode-driving-map-marker",
    "mode-driving-map-marker-label",
    label,
  );
}

export function createModeWalkingMarkerElement(label = "") {
  return createLabeledMarkerElement(
    "mode-walking-map-marker",
    "mode-walking-map-marker-label",
    label,
  );
}

export function createModeRandomMarkerElement(pointType = "") {
  const normalizedPointType = normalizePointType(pointType);
  const iconByType = {
    building: `
        <svg viewBox="0 0 24 24" class="mode-random-map-marker-icon" aria-hidden="true" >
          <path fill="currentColor" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" d="M4 21h16v-2H4v2zm2-3h3V4H6v14zm5 0h3V7h-3v11zm5 0h2v-9h-2v9z"/>
        </svg>
      `,
    parking: `
        <svg viewBox="0 0 24 24" class="mode-random-map-marker-icon" aria-hidden="true">
          <path fill="currentColor" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" d="M7 3h5a5 5 0 1 1 0 10H9v8H7V3zm2 2v6h3a3 3 0 1 0 0-6H9z"/>
        </svg>
      `,
    restaurant: `
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-tools-kitchen-2">
	      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
	      <path d="M19 3v12h-5c-.023 -3.681 .184 -7.406 5 -12m0 12v6h-1v-3m-10 -14v17m-3 -17v3a3 3 0 1 0 6 0v-3" />
      </svg>  
      `,
    hotel: `
        <svg viewBox="0 0 24 24" class="mode-random-map-marker-icon" aria-hidden="true">
          <path fill="currentColor" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" d="M5 2h2v8h10V2h2v20h-2v-6H7v6H5V2zm2 10v2h10v-2H7z"/>
        </svg>
      `,
  };
  const element = document.createElement("div");
  element.className = "mode-random-map-marker";
  element.dataset.pointType = normalizedPointType;
  element.innerHTML = iconByType[normalizedPointType] || iconByType.building;
  return element;
}
